/**
 * Created by fers on 01.07.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

export default class MoreLink extends React.Component {

    static propTypes = {
		link: PropTypes.string.isRequired,
        service: PropTypes.string.isRequired,
    };

    render() {
        return (
            <small>
				<a href={this.props.link} target="_blank">
					<FormattedMessage defaultMessage="more on {service}" id="component.seeMore" values={{service: this.props.service}} />
				</a>
			</small>
        );
    }
}
